import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import "../../rules-regulations.css";
import API_URL from "../../config/constant";
import bgRulesRegulations from "../../assets/images/bg-rules-regulations.png";
import EffectSplatterWhite from "../../assets/images/effect-splatter-white.png";

export default function RulesRegulation() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const { t } = useTranslation();

    const [data, setData] = useState(null);
    const locale = useSelector((state) => state.locale.locale);
    useEffect(() => {
        const fetchAboutData = async () => {
            try {
                const response = await fetch(`${API_URL}/rules-regulations?lang=${locale}`);
                if (!response.ok) {
                    throw new Error("Data not found");
                }
                const res = await response.json();
                if (res.length < 1) {
                    throw new Error("Data not found");
                }
                setData(res);
            } catch (error) {
                setData(t("raceinfo.rr", { returnObjects: true }));
            }
        };

        fetchAboutData();
    }, [t, locale]);

    return (
        <div className="relative min-w-0 overflow-x-hidden text-white md:px-0 px-4 md:pb-80 pb-40 bg-primary md:bg-rulesRegistration bg-cover bg-no-repeat">
            <img
                src={EffectSplatterWhite}
                alt="Decorative splatter effect"
                className="pointer-events-none absolute top-64 md:top-24 left-96 z-[1] object-contain opacity-80 select-none"
            />
            {/* <div className="relative min-h-[240px] lg:min-h-[300px] bg-bgBannerPage bg-contain md:bg-cover bg-no-repeat top-[86px] md:top-[109px] 2xl:top-[136px] flex justify-center items-center">
                <PageHeadline title={t("raceinfo.rrHeader")} />
            </div> */}
            <div className="relative top-36 md:top-40 md:px-14 px-0">
                {/* <div className="basis-full py-8 max-md:max-w-[200px] max-md:text-wrap">
                    <span className="font-superWonder text-5xl md:text-8xl text-brandYellow">{t("raceinfo.rrHeader")}</span>
                </div> */}
                <div className={`container w-full mx-auto font-wantCoffee mb-12 ${locale === 'en' ? 'bg-textBgRulesRegulationsEn' : 'bg-textBgRulesRegulationsId'} bg-no-repeat bg-left min-h-[180px] md:min-h-[240px] ${locale === 'en' ? 'bg-[length:400px_auto] md:bg-[length:540px_auto]' : 'bg-[length:400px_auto] md:bg-[length:540px_auto]'}`}>
                    <p className={`text-6xl md:text-[5rem] relative top-8 md:top-10 leading-none text-secondary ${locale === 'en' ? 'left-12 md:left-16' : 'left-16'}`}>{t("raceinfo.rrHeader")}</p>
                    <p className={`text-6xl md:text-[5rem] relative top-8 md:top-10 leading-none text-secondary ${locale === 'en' ? 'left-12 md:left-16' : 'left-16'}`} style={{ letterSpacing: '3px' }}>{t("raceinfo.rrHeaderSub")}</p>
                </div>
                <div className="relative container mx-auto w-full z-10">
                    <img
                        src={bgRulesRegulations}
                        alt=""
                        className="pointer-events-none select-none absolute md:z-20 w-[min(100vw,480px)] md:w-[min(42vw,420px)] -left-2 md:-left-16 max-md:-bottom-48 md:top-[42rem] object-cover md:object-contain md:object-left-top"
                        aria-hidden
                    />
                    <div className="relative z-10 min-h-screen w-full font-poppins text-[#164481] bg-white rounded-3xl px-8 py-6 pt-14 md:pt-10 md:pl-10 md:max-h-[800px]">
                        <div className="">
                            <div className="flex items-start justify-start flex-col gap-y-10">
                                <p className="text-start md:w-1/2 font-semibold text-md text-mutedGrey">{t("raceinfo.rrTitle")}</p>
                            </div>
                            <div className="flex md:flex-row flex-col gap-x-12 mt-10">
                                <div className="flex flex-col md:gap-y-10 gap-y-5 mb-10 pr-8 md:border-r border-brandYellow font-roboto">
                                    {data?.map((parent, index) => (
                                        <button
                                            key={index}
                                            onClick={() => setCurrentIndex(index)}
                                            className={`uppercase text-start w-52 text-lg font-roboto tracking-widest ${currentIndex === index
                                                ? "text-primary font-bold max-md:border-b max-md:border-brandYellow"
                                                : "text-neutral-500 font-bold max-md:border-none"
                                                }`}
                                        >
                                            {parent.title}
                                        </button>
                                    ))}
                                </div>
                                <div className="max-h-[640px] overflow-y-auto overscroll-y-contain pr-1 [scrollbar-gutter:stable]">
                                    <ol className="font-light list-decimal list-inside leading-loose max-md:px-4">
                                        {data && data[currentIndex].data && data[currentIndex].data.map((text, key) => <li className="text-justify font-roboto font-medium text-mutedGrey" key={key} dangerouslySetInnerHTML={{ __html: text.desc }}></li>)}
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
